import axios, { AxiosInstance } from 'axios';
import { interceptRequest } from '../interceptors/request';
import { interceptResponse } from '../interceptors/response';
import { getApiCustomConfig } from './custom';

let _service = null as null | AxiosInstance;
export function getService() {
  // 使用之前创建的实例
  if (_service) {
    return _service;
  }
  // 创建axios实例
  const { baseURL, ajaxTimeout } = getApiCustomConfig();
  const service = axios.create({
    baseURL,
    withCredentials: true, // 是否在跨域情况下发送 cookie
    timeout: ajaxTimeout, // 请求超时时间
    // adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
    //   enabledByDefault: true, // 是否开启axios缓存
    //   maxAge: Infinity, // 缓存的过期 时间
    // }),
  });
  // 请求拦截
  interceptRequest(service);
  // 响应拦截
  interceptResponse(service);
  // 返回示例
  return (_service = service);
}
